import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
	// #0068B4
	confirmButtonColor: 'rgba(0, 104, 180, 1)',
};

Vue.use(VueSweetalert2, options);
